import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Header from "components/header";
import Figure from "components/figure";
import Richard from "./Richard.jpg";
export const _frontmatter = {
  "title": "Privacy"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title="Contact" mdxType="Header" />
    <section className="content container">
      <div className="columns is-vcentered">
        <div className="column is-3 is-offset-1" data-aos="fade-up">
          <Figure caption="Stacy Fiehler,<br/>Head of Marketing & Communications" className="is-rounded" data-aos="fade-up" mdxType="Figure">
            <span style={{
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "2000px"
            }}>   
              <img src={Richard} alt="Richard Rogers, responsAbility Investments" />
            </span>
          </Figure>
        </div>
        <div className="is-6 column is-offset-1 pb-6" data-aos="fade-up">
          <p><strong parentName="p">{`Stacy Fiehler`}</strong></p>
          <p>{`responsAbility Investments`}<br parentName="p"></br>{`
`}{`Phone: +41 44 403 2151`}<br parentName="p"></br>{`
`}{`Email: `}<a href="mailto:media@responsAbility.com">{`media`}{`[at]`}{`responsAbility.com`}</a></p>
        </div>
      </div>
    </section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      